"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PinnedEngagementActionTypes = {
  PIN_ENGAGEMENT: 'PIN_ENGAGEMENT',
  UNPIN_ENGAGEMENT: 'UNPIN_ENGAGEMENT',
  SET_PINNED_ENGAGEMENT_ID: 'SET_PINNED_ENGAGEMENT_ID'
};
var _default = PinnedEngagementActionTypes;
exports.default = _default;
module.exports = exports.default;